<template>
  <graphql-requester
    :style="style"
    :gql="$options.GET_LOCATIONS"
    v-slot="{ data, loading }"
    @result="onResult"
    class="bg-color p-6"
  >
    <app-loading v-if="loading" />
    <div v-else-if="data && !loading">
      <sameday-filters
        :params="locations"
        v-slot="{ filteredLocations, hasLocations, onFilterLocations }"
      >
        <sameday-sort-distance
          v-if="hasLocations"
          :params="filteredLocations"
          v-slot="{ sortedLocations }"
        >
          <app-loading v-if="!sortedLocations" />
          <sameday-view-more
            :params="sortedLocations"
            v-slot="{ slicedLocations }"
            v-else
            @on:scroll="$emit('on:scroll', $event)"
          >
            <sameday-masonry v-slot="{ onLayout }">
              <component
                :is="'sameday-item'"
                v-for="el in slicedLocations"
                :key="`location-${el.location_id}`"
                :params="el"
                :search="search"
                @on:loaded="onLayout"
                @on:form="$emit('on:form', $event)"
                @has:services="onFilterLocations"
              ></component>
            </sameday-masonry>
          </sameday-view-more>
        </sameday-sort-distance>
        <sameday-offline v-else />
      </sameday-filters>
    </div>
    <app-error v-else />
  </graphql-requester>
</template>

<script>
import { GET_LOCATIONS } from "@/graphql";
import GraphqlRequester from "@/components/GraphqlRequester.vue";
import AppLoading from "@/components/AppLoading.vue";
import AppError from "@/components/AppError.vue";
import SamedayItem from "@/components/Sameday/SamedayItem.vue";
import SamedayMasonry from "@/components/Sameday/SamedayMasonry.vue";
import SamedayFilters from "@/components/Sameday/SamedayFilters.vue";
import SamedaySortDistance from "@/components/Sameday/SamedaySortDistance.vue";
import SamedayOffline from "@/components/Sameday/SamedayOffline.vue";
import SamedayViewMore from "@/components/Sameday/SamedayViewMore.vue";

export default {
  GET_LOCATIONS,
  components: {
    AppLoading,
    AppError,
    GraphqlRequester,
    SamedayItem,
    SamedayMasonry,
    SamedayFilters,
    SamedaySortDistance,
    SamedayOffline,
    SamedayViewMore,
  },
  props: {
    search: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      locations: [],
    };
  },
  computed: {
    style() {
      return {
        "--bg-color":
          this.$store.state.config.colors.containerBackground || "#FFFFFF",
      };
    },
  },
  methods: {
    onResult(data) {
      this.locations = data?.getScheduleDetails?.locations || [];
      // this.locations = [this.locations[3]];
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: var(--bg-color);
}
</style>
